<template>
    <div class="h-full w-full flex flex-col">
        <PostTrainingForm mode="create" :entities="entities" @created="onCreated" @close="$emit('close')" />
    </div>
</template>

<script>
import PostTrainingForm from "./form.vue";
export default {
    name: "post-training-create",
    emits: ["created", "close"],
    props: ["entities"],
    components: { PostTrainingForm, },
    methods: {
        onCreated(msg) {
            this.$emit('created', msg);
        },
    },
}
</script>